<template>
  <div v-if="$store.getters.isAuthenticated" id="admin" class="flex h-screen bg-gray-200 font-roboto">
    <Sidebar />

    <div class="flex-1 flex flex-col overflow-hidden">
      <Header />

      <main class="flex-1 overflow-x-hidden overflow-y-auto bg-gray-200">
        <div class="px-6 py-8">
<!--          <breadcrumbs/>-->
          <router-view/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from "../../components/admin/Sidebar.vue";
import Header from "../../components/admin/Header.vue";
// import Breadcrumbs from "../../components/Breadcrumbs.vue";

export default {
  components: {
    Sidebar,
    Header,
    // Breadcrumbs,
  }
}
</script>